import React from 'react';
import PropTypes from 'prop-types';
import { trim, keys } from 'lodash';

const CourseInfo = ({ data: {
    directions: { courseAddress, rpParking, rpDisabled, howToGetThere },
    admission: { rpAdmissionPrices, rpChildren },
} }) => (
    <section className="cp-courseInfo">
        {courseAddress &&
            <div className="cp-courseInfo__block">
                <h3 className="cp-courseInfo__title">Address</h3>
                {courseAddress}
            </div>
        }
        {(trim(rpAdmissionPrices) || trim(rpChildren)) &&
            <div className="cp-courseInfo__block">
                <h3 className="cp-courseInfo__title">Admission</h3>
                {trim(rpAdmissionPrices) &&
                    <p className="cp-courseInfo__row">
                        General Admission: {rpAdmissionPrices}
                    </p>
                }
                {trim(rpChildren) &&
                    <p className="cp-courseInfo__row">
                        Children: {rpChildren}
                    </p>
                }
            </div>
        }
        <div className="cp-courseInfo__block">
            <h3 className="cp-courseInfo__title">How to get there</h3>
            {keys(howToGetThere).map(key => (
                howToGetThere[key] ? (
                    <span key={key}>
                        <span className="cp-courseInfo__subtitle">{key}: </span>
                        {howToGetThere[key]}&nbsp;
                    </span>
                    ) : null
                )
            )}
        </div>
        {trim(rpParking) &&
            <div className="cp-courseInfo__block">
                <h3 className="cp-courseInfo__title">Parking</h3>
                {rpParking}
            </div>
        }
        {trim(rpDisabled) &&
            <div className="cp-courseInfo__block">
                <h3 className="cp-courseInfo__title">Disabled</h3>
                {rpDisabled}
            </div>
        }
    </section>
);

CourseInfo.propTypes = {
    data: PropTypes.shape({
        directions: PropTypes.shape({
            courseAddress: PropTypes.string,
            rpParking: PropTypes.string,
            rpDisabled: PropTypes.string,
            howToGetThere: PropTypes.shape({
                air: PropTypes.string,
                bus: PropTypes.string,
                rail: PropTypes.string,
                riverbus: PropTypes.string,
                road: PropTypes.string,
            }).isRequired,
        }).isRequired,
        admission: PropTypes.shape({
            rpAdmissionPrices: PropTypes.string,
            rpChildren: PropTypes.string,
        }).isRequired,
    }).isRequired,
};

export default CourseInfo;



// WEBPACK FOOTER //
// ./src/js/course/courseInfo/CourseInfo.jsx